import { formatInTimeZone } from 'date-fns-tz';

function calendarDay(year: number, month: number, day: number): Date {
  return new Date(Date.UTC(year, month - 1, day, 12));
}

function formatUtcDay(date: Date): string {
  return date.toISOString().slice(0, 10);
}

/**
 * Monday-start week in the studio zone, formatted for trial APIs (yyyy-MM-dd).
 * Invalid zones fall back to UTC so the range does not follow the browser clock.
 */
export function getTrialWeekDateRange(
  referenceDate: Date = new Date(),
  timeZone?: string | null,
) {
  const zone = timeZone?.trim() || 'UTC';
  let ymd: string;
  try {
    ymd = formatInTimeZone(referenceDate, zone, 'yyyy-MM-dd');
  } catch {
    ymd = formatInTimeZone(referenceDate, 'UTC', 'yyyy-MM-dd');
  }

  const [year, month, day] = ymd.split('-').map(Number);
  const noon = calendarDay(year, month, day);
  const weekday = noon.getUTCDay();
  const mondayOffset = weekday === 0 ? -6 : 1 - weekday;
  const monday = calendarDay(year, month, day + mondayOffset);
  const sunday = calendarDay(year, month, day + mondayOffset + 6);

  return {
    startDate: formatUtcDay(monday),
    endDate: formatUtcDay(sunday),
  };
}
